import React from 'react'

const BothWayArrow = () => {
  return (
    <svg width='8' height='11' viewBox='0 0 8 11' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M1.71589 0.083125L0.0883951 1.71062C-0.0982716 1.89146 0.0300617 2.20646 0.292562 2.20646H1.33673V5.71229C1.33673 6.03312 1.59923 6.29563 1.92006 6.29563C2.24089 6.29563 2.5034 6.03312 2.5034 5.71229V2.20646H3.54756C3.81006 2.20646 3.9384 1.89146 3.75173 1.71062L2.12423 0.083125C2.0134 -0.0277083 1.82673 -0.0277083 1.71589 0.083125ZM6.0034 8.05146V4.54562C6.0034 4.22479 5.74089 3.96229 5.42006 3.96229C5.09923 3.96229 4.83673 4.22479 4.83673 4.54562V8.05146H3.79256C3.53006 8.05146 3.40173 8.36646 3.58839 8.54729L5.21589 10.169C5.33256 10.2798 5.51339 10.2798 5.63006 10.169L7.25756 8.54729C7.44423 8.36646 7.31006 8.05146 7.05339 8.05146H6.0034Z' />
    </svg>
  )
}

export default BothWayArrow
